function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoicemailOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.4,13.49a1.3,1.3,0,0,0,1.07-.65,2.57,2.57,0,0,0,.35-1.35c-.11-1.22-1.5-2.22-2.36-2.8-7.7-5.24-5.78-5.63-11.63-1.42-1.28.93-3.06,1.86-3.81,3a2.24,2.24,0,0,0-.14,2.63c.58.65,1.08.59,1.93.59h12.9A15.88,15.88,0,0,0,22.4,13.49Z",
    style: {
      fill: "#eac282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.66,23.09a3,3,0,0,0-2.14-.93,3.18,3.18,0,0,0-3.14,3.15,3.11,3.11,0,0,0,.43,1.59H18.53A4,4,0,0,0,19,25.33a3.12,3.12,0,0,0-5.34-2.25,3.4,3.4,0,0,0-.86,2.25,3.24,3.24,0,0,0,.86,2.14,3.13,3.13,0,0,0,2.24.92h7.67a3.15,3.15,0,0,0,3-3.08A3.09,3.09,0,0,0,25.66,23.09ZM17,26.34a1.78,1.78,0,0,1-1.15.5,1.7,1.7,0,0,1-1.56-1.57,1.56,1.56,0,0,1,.49-1.14,1.45,1.45,0,0,1,1.07-.43,1.62,1.62,0,0,1,1.15.43,1.45,1.45,0,0,1,.42,1.14A1.4,1.4,0,0,1,17,26.34Zm7.55,0a1.52,1.52,0,0,1-1.06.5,1.66,1.66,0,0,1-1.15-.5,1.58,1.58,0,0,1,1-2.64h.2a1.37,1.37,0,0,1,1.06.43,1.53,1.53,0,0,1,.09,2.16h0l-.08.07Z",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,23.2h-.07a3.07,3.07,0,0,0-.82-1.07,4.1,4.1,0,0,0-3-1.29,4.29,4.29,0,0,0-3,1.29,4.35,4.35,0,0,0-.74,1.07H7.19a1.64,1.64,0,0,1-1.64-1.29,8.79,8.79,0,0,1-.07-1.36V13.37c1.42,1.34,7.77,5.83,9.2,5.83s7.7-4.5,9.14-5.85v7.41h0a4.34,4.34,0,0,0-3.08,1.29A4.25,4.25,0,0,0,20,23.2Z",
    style: {
      fill: "#eac282"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoicemailOpen);
export default __webpack_public_path__ + "static/media/voicemail-open.e91f0fef.svg";
export { ForwardRef as ReactComponent };